exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".projects-container{height:100%}.projects-container .projects-feature-image__img{width:100%;height:400px}.projects-container .projects-documentation__card{padding:20px}.projects-container .projects-documentation__card img{max-width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-567b9f5d","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/project-documentations/project-documentations.vue
// module id = 211
// module chunks = 0